import React, { useState } from "react";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import IconButton from "@mui/material/IconButton";
import DialogImportExcelSpreadsheet from "../dialogs/DialogImportExcelSpreadsheet";
import { useSnackbar } from "notistack";
import { gapi } from "gapi-script";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import Tooltip from "@mui/material/Tooltip";
import loadGoogleClient from "./LoadGoogleClient";
import * as XLSX from 'xlsx';
import { useProjectStore } from "../model/ProjectStore";

const ImportActualsFromXLSX = () => {
  const project = useProjectStore();
  const [createSheetStarted, setCreateSheetStarted] = useState(false);
  const [createSheetCompleted, setCreateSheetCompleted] = useState(false);

  const [exportEvaOpen, setExportEvaOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();


  const handleCreate = () => {
    setExportEvaOpen(true);
  };

  const handleExportEVAClose = () => {
    setExportEvaOpen(false);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setCreateSheetStarted(false);
    setCreateSheetCompleted(false);
  };

  const handleFileUpload = (e) => {
    
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      //gemini generated boiler plate
      const arrayBuffer = event.target.result;
      const workbook = XLSX.read(arrayBuffer, { type: 'buffer' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      //app code
      jsonData.forEach(row => {
        let task = project.rootTaskPackage.getTaskByCode(row.Code);
        if (task) {
          task.applyActualsAsTotals(row.Period, row.Progress, row.Cost, row.Note);
        }
      });
      console.debug(JSON.stringify(jsonData));

      setCreateSheetStarted(false);
      setExportEvaOpen(false); 
      enqueueSnackbar("Import Finished!", {
            variant: "success",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
          })
    };
    
    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="AddGoogleSheetButton">
      <Tooltip title="Import Spreadsheet" aria-label="Import Period Actuals From Excel">
        <IconButton onClick={() => handleCreate()} color="inherit">
          <NoteAddIcon />
        </IconButton>
      </Tooltip>
      <DialogImportExcelSpreadsheet
        open={exportEvaOpen}
        onCancel={handleExportEVAClose}
        onSave={handleFileUpload}
      />
      <Snackbar
        title="Read Spreadsheet Start"
        open={createSheetStarted}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          sx={{ width: "100%" }}
        >
          Reading Spreadsheet for Import...
        </Alert>
      </Snackbar>
      <Snackbar
        title="Read Spreadsheet End"
        open={createSheetCompleted}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Successfully Imported the Spreadsheet
        </Alert>
      </Snackbar>
    </div>
  );
}

export default ImportActualsFromXLSX;
